import React, { Fragment, useEffect, useState } from "react";
import { ProductList } from "../components/product";
import { PageBanner } from "../components/common";
import { useDispatch, useSelector } from "react-redux";
import { getGamesList, ipAddress, visitorView } from "../appRedux/actions/games";
import { useParams } from "react-router-dom";

const ProductView = () => {
  const dispatch = useDispatch();
  const { promoterCode } = useParams();
  const { gamesType, isUpdate, queryInfo, page, limit, totalRecords, ipAddressInfo } = useSelector(
    (state) => ({
      gamesType: state.games.gamesType,
      isUpdate: state.games.isUpdate,
      queryInfo: state.games.queryInfo,
      page: state.games.queryInfo.page,
      limit: state.games.queryInfo.limit,
      totalRecords: state.games.totalRecords,
      ipAddressInfo: state.games.ipAddressInfo,
    })
  );
  // useEffect(() => {

  // }, []);

  useEffect(() => {
    if (isUpdate) {
      dispatch(getGamesList({ ...queryInfo }));
    } else {
      dispatch(getGamesList({ ...queryInfo, page: 0, limit: 10 }));
    }
    dispatch(ipAddress());
  }, []);
  useEffect(() => {
    if (ipAddressInfo && ipAddressInfo.ip && promoterCode) {
      console.log({ promoterCode });
      dispatch(
        visitorView({
          promoterCode,
          ipAddress: ipAddressInfo.ip,
          country: ipAddressInfo.country_name,
          city: ipAddressInfo.country,
          ipAddressInfo,
        })
      );
    }
  }, [ipAddressInfo, promoterCode]);
  return (
    <Fragment>
      <PageBanner
        // pageTitle="About Us"
        homePageUrl="/"
        homePageText="GGPL"
        activePageText="Play Store"
      />
      <ProductList />
    </Fragment>
  );
};

export default ProductView;
